"use strict";

/**
 *  平台设置
 *  @module 光照属性
 */

import Vue from "@/main";

// 默认数据
const form = {
  lightMode: "0", //光照时间
};

// 保存提交 (存储至localStorage)
const saveIlluminationSettings = (data) => {
  localStorage.setItem("illuminationSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureIlluminationSettings = () => {
  if (localStorage.getItem("illuminationSettings")) {
    return JSON.parse(localStorage.getItem("illuminationSettings"));
  } else {
    localStorage.setItem("illuminationSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setIlluminationEffect = (data, map = Vue.$GLOBAL.map) => {
  const { lightMode } = data;
  let dt = new Date();
  switch (lightMode) {
    case "0":
      map.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      if (Vue.$GLOBAL.mapClone)
        Vue.$GLOBAL.mapClone.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      break;
    case "1":
      dt.setHours(8);
      map.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      if (Vue.$GLOBAL.mapClone)
        Vue.$GLOBAL.mapClone.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      break;
    case "2":
      dt.setHours(20);
      map.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      if (Vue.$GLOBAL.mapClone)
        Vue.$GLOBAL.mapClone.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      break;
    case "3":
      dt.setHours(16);
      map.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      if (Vue.$GLOBAL.mapClone)
        Vue.$GLOBAL.mapClone.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      break;

    default:
      map.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      if (Vue.$GLOBAL.mapClone)
        Vue.$GLOBAL.mapClone.clock.currentTime = Cesium.JulianDate.fromDate(dt);
      break;
  }
  // Vue.$GLOBAL.map.viewer.scene.sun.show = false;
};

export {
  saveIlluminationSettings,
  exposureIlluminationSettings,
  setIlluminationEffect,
};
